import type { PrV2FaviconVisualState } from './types';

import { PR_V2_FAVICON_VISUAL_STATE } from './types';

const CUBIC_BASE_FAVICON_SVG =
  '<rect width="64" height="64" rx="14" fill="#09090b"/><rect x="12" y="12" width="40" height="40" rx="9" fill="#ffffff"/>';

const FAVICON_STATUS_BADGE = (fill: string) => `<circle cx="48" cy="46" r="12.5" fill="${fill}"/>`;

const PR_V2_FAVICON_SVG_BY_STATE: Record<PrV2FaviconVisualState, string> = {
  [PR_V2_FAVICON_VISUAL_STATE.Pending]: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${CUBIC_BASE_FAVICON_SVG}${FAVICON_STATUS_BADGE('#D29922')}</svg>`,
  [PR_V2_FAVICON_VISUAL_STATE.Success]: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${CUBIC_BASE_FAVICON_SVG}${FAVICON_STATUS_BADGE('#1A7F37')}</svg>`,
  [PR_V2_FAVICON_VISUAL_STATE.Failure]: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${CUBIC_BASE_FAVICON_SVG}${FAVICON_STATUS_BADGE('#CF222E')}</svg>`,
};

export const PR_V2_FAVICON_HREF_BY_STATE = Object.fromEntries(
  Object.entries(PR_V2_FAVICON_SVG_BY_STATE).map(([state, svg]) => [
    state,
    `data:image/svg+xml,${encodeURIComponent(svg)}`,
  ]),
) as Record<PrV2FaviconVisualState, string>;
